import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import Slider from "react-slick";
import { __ } from "services/Translator";
import api from "services/api";

export default function PopularGameSlider(props) {
  // popular games settings
  const popularNextLoad = () => {
    popularGameRef.current.slickNext();
  };
  const popularPrevLoad = () => {
    popularGameRef.current.slickPrev();
  };

  const popularGamesSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },

      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          className: "center",
          centerMode: true,
        },
      },
    ],
  };

  const popularGameRef = useRef();

  const [highlightedGames, setHighlightedGames] = useState([]);
  const getHighlightedGames = async (ev) => {
    var response = await api.get("/get-highlighted-games");
    if (response.status === 200) {
      setHighlightedGames(response.data.highlightedGames);
    }
  };

  useEffect(() => {
    getHighlightedGames();
  }, []);

  return (
    <section className="game_section popular_games">
      <div className="container-xxl container-xl game_container padding_top_bottom_30">
        {/* <div className="section_title">{__("Our Selection")}</div>
        <div className="paragraph text-center margin_bottom_30">
          {__(
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod"
          )}
          <br />
          {__("tempor, Lorem ipsum dolor .")}
        </div>
        <br id="scrollTarget" /> */}
        <div className="section_headline">
          <div className="headline_text">{__("Popular Games")}</div>
          <div className="headline_action">
            <button onClick={popularPrevLoad} className="action_btn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="20"
                fill="white"
                class="bi bi-arrow-left"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
                />
              </svg>
              {__("Prev")}
            </button>
            <button onClick={popularNextLoad} className="action_btn">
              {__("Next")}

              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="20"
                fill="white"
                class="bi bi-arrow-right"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                />
              </svg>
            </button>
          </div>
        </div>
        <br />
        {highlightedGames.length > 0 && (
          <Slider ref={popularGameRef} {...popularGamesSettings}>
            {highlightedGames.map((item, index) => (
              <div className="slick_item">
                <div className="single_game popular_game">
                  <div className="badge popular_game">{__("Popular")}</div>
                  <div className="games_image popular_games">
                    <img
                      alt="game image"
                      src={item.highlightedGameDetails.dpUrl}
                    />
                  </div>

                  <div className={"games_details " + props.landingType}>
                    <div className="game_amounts">
                      <div className="amount_left">
                        <div className="primary_text">
                          {__("today's prize")}
                        </div>
                        <div className="balance">
                          {item.highlightedGameDetails.prize}
                        </div>
                      </div>
                      <div className="amount_left">
                        <div className="primary_text">{__("discount")}</div>
                        <div className="balance gradiant">
                          {item.highlightedGameDetails.discount}
                        </div>
                      </div>
                    </div>

                    <div className="game_play">
                      <div className="play_left">
                        <div className="play_text">
                          {" "}
                          {__("Relevant information")}
                        </div>
                        <div className="date">231.212</div>
                      </div>
                      <div className="play_left">
                        <Link
                          className={" " + props.landingType}
                          to={"/play/" + item.slug}
                        >
                          {__("Play Now")}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}

            <div className="slick_item">
            <div className="single_game popular_game">
              <div className="badge popular_game">{__("Popular")}</div>
              <div className="games_image popular_games">
                <img
                  alt="game image"
                  src="https://chimpbytes.imgix.net/pop-game-1.png?&dpr=1&format=auto&auto=format&q=50&w=298&h=445&max-age=2629056"
                />
              </div>

              <div className={"games_details " + props.landingType}>
                <div className="game_amounts">
                  <div className="amount_left">
                    <div className="primary_text">{__("today's prize")}</div>
                    <div className="balance">124.00 ETH</div>
                  </div>
                  <div className="amount_left">
                    <div className="primary_text">{__("discount")}</div>
                    <div className="balance gradiant">29.49</div>
                  </div>
                </div>

                <div className="game_play">
                  <div className="play_left">
                    <div className="play_text">
                      {" "}
                      {__("Relevant information")}
                    </div>
                    <div className="date">231.212</div>
                  </div>
                  <div className="play_left">
                    <Link className={" " + props.landingType} to="#">
                      {__("Play Now")}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </Slider>
        )}
      </div>
    </section>
  );
}
